import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["container", "form", "input"]

    connect() {
        this.scrollToBottom()
    }

    scrollToBottom() {
        if (this.hasContainerTarget) {
            this.containerTarget.scrollTop = this.containerTarget.scrollHeight
        }
    }

    submitOnEnter(event) {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault()
            this.formTarget.requestSubmit()
            this.inputTarget.value = ""
        }
    }

    // Called when a new message is added via Turbo Stream
    messageTargetConnected() {
        this.scrollToBottom()
    }
}
